export default __webpack_public_path__ + "static/media/5050@3x.0279bb06.png";